/* eslint-disable */
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createPO = createAsyncThunk('createPO', async (params, { rejectWithValue }) => {
  return await axios({
    data: params,
    method: 'post',
    url: `/api/purchase-order`,
    baseURL: process.env.REACT_APP_API_BASE_URL,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return rejectWithValue(error.response.data);
    });
});

export const getPurchaseOrder = createAsyncThunk(
  'getPurchaseOrder',
  async (params, { rejectWithValue }) => {
    return await axios({
      method: 'get',
      params: params,
      url: `/api/purchase-order`,
      baseURL: process.env.REACT_APP_API_BASE_URL,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);

export const updatePurchaseOrder = createAsyncThunk(
  'updatePurchaseOrder',
  async ({ params, id }, { rejectWithValue }) => {
    return await axios({
      data: params,
      method: 'put',
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/api/purchase-order/${id}?include[]=item`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);

export const approveOrderForm = createAsyncThunk(
  'approveOrderForm',
  async (id, { rejectWithValue }) => {
    return await axios({
      method: 'get',
      url: `/api/purchase-order/approve/${id}`,
      baseURL: process.env.REACT_APP_API_BASE_URL,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);

export const denyOrderForm = createAsyncThunk(
  'denyOrderForm',
  async ({ params, id }, { rejectWithValue }) => {
    return await axios({
      method: 'put',
      data: params,
      url: `/api/purchase-order/reject/${id}`,
      baseURL: process.env.REACT_APP_API_BASE_URL,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.data);
      });
  },
);
